import React from 'react';
import cx from 'classnames';
import styles from './ButtonGroup.module.scss';
import type { ButtonGroupProps } from './ButtonGroup.types';
import { renderButtonItem } from './utils';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

/**
 * ButtonGroup component definition.
 */
const ButtonGroup = (props: ButtonGroupProps) => {
    const { className, children, align = 'Horizontal', type = 'Outlined' } = props;
    const buttonItems = renderButtonItem(children);
    const variantProps = useBuildVariantProps(
      'button-group',
      { align, type },
    );
    return <ul 
      className={cx(
        styles.buttonGroup,
          className,
      )}
      {...variantProps}
    >
        {buttonItems}
    </ul>;
};

export default ButtonGroup;
